(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const selector = document.querySelector('.mb-selector');
    if (!selector) return;

    const state = {
      selectedCard: null,
      selectedProductId: null,
      selectedProductTitle: null
    };

    // DOM Elements
    const cards = selector.querySelectorAll('.mb-selector__card');

    // Initialize
    setupEventListeners();

    /**
     * Setup all event listeners
     */
    function setupEventListeners() {
      // Card selection - clicking anywhere on card
      cards.forEach(card => {
        const ctaButton = card.querySelector('[data-card-cta]');
        
        if (ctaButton) {
          ctaButton.addEventListener('click', (e) => {
            e.stopPropagation();
            handleCardSelection(card);
          });
        }

        // Optional: make entire card clickable
        card.addEventListener('click', () => {
          handleCardSelection(card);
        });
      });
    }

    /**
     * Handle card selection
     */
    function handleCardSelection(card) {
      // Remove selected class from all cards
      cards.forEach(c => {
        c.classList.remove('mb-selector__card--selected');
        const btn = c.querySelector('[data-card-cta]');
        if (btn) {
          btn.textContent = selector.closest('section').dataset.buttonText || 'Select This Mattress';
        }
      });

      // Add selected class to clicked card
      card.classList.add('mb-selector__card--selected');

      // Update button text
      const selectedButton = card.querySelector('[data-card-cta]');
      if (selectedButton) {
        selectedButton.textContent = 'Selected ✓';
      }

      // Update state
      state.selectedCard = card;
      state.selectedProductId = card.dataset.productId;

      // Get product title from card
      const titleElement = card.querySelector('.mb-selector__card-title');
      state.selectedProductTitle = titleElement ? titleElement.textContent.trim() : '';

      console.log('Selected product:', {
        id: state.selectedProductId,
        title: state.selectedProductTitle
      });

      // TODO: Open modal with product details
      // This is where you'll trigger your modal
      // openProductModal(state.selectedProductId);
      
      // Dispatch custom event for modal to listen to
      document.dispatchEvent(new CustomEvent('mattress:selected', {
        detail: {
          productId: state.selectedProductId,
          productTitle: state.selectedProductTitle,
          card: state.selectedCard
        }
      }));
    }

    // Store button text for resetting
    const section = selector.closest('section');
    if (section) {
      const buttonText = selector.querySelector('[data-card-cta]')?.textContent.trim() || 'Select This Mattress';
      section.dataset.buttonText = buttonText;
    }
  }
})();